@if (store.isPunchoutPromo()) {
  <ideal-punchout-promo-ribbon *renderInProductResult="LayoutTargets.Price" />
}

<ideal-lead-time-notification-chip [short]="true" *renderInProductResult="LayoutTargets.Stock" [stockLocation]="stockLocation()" />
